<div class="pdf-color-settings">
  <div *ngIf="loading" class="loading-container">
    <nx-spinner nxSize="medium"></nx-spinner>
  </div>

  <div nxLayout="grid" *ngIf="!loading && settings">
    <div nxRow="">
      <div nxCol="12">
        <h4 class="section-title">{{'pdfColors.sections.coverPage' | caption}}</h4>
      </div>
      <ng-container *ngFor="let field of getFieldsBySection('coverPage')">
        <div nxCol="12,12,6,4" class="color-field">
          <div class="color-label">{{field.label | caption}}</div>
          <div class="color-picker-wrapper">
            <div class="color-preview"
                 [style.backgroundColor]="settings[field.key]"
                 (click)="toggleColorPicker(field.key)">
            </div>
            <span class="color-value">{{settings[field.key]}}</span>
          </div>
          <div class="color-picker-container" [class.open-upward]="openUpward" *ngIf="activeColorPicker === field.key">
            <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
          </div>
        </div>
      </ng-container>
    </div>

    <div nxRow="">
      <div nxCol="12">
        <h4 class="section-title">{{'pdfColors.sections.toc' | caption}}</h4>
      </div>
      <ng-container *ngFor="let field of getFieldsBySection('toc')">
        <div nxCol="12,12,6,4" class="color-field">
          <div class="color-label">{{field.label | caption}}</div>
          <div class="color-picker-wrapper">
            <div class="color-preview"
                 [style.backgroundColor]="settings[field.key]"
                 (click)="toggleColorPicker(field.key)">
            </div>
            <span class="color-value">{{settings[field.key]}}</span>
          </div>
          <div class="color-picker-container" [class.open-upward]="openUpward" *ngIf="activeColorPicker === field.key">
            <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
          </div>
        </div>
      </ng-container>
    </div>

    <div nxRow="">
      <div nxCol="12">
        <h4 class="section-title">{{'pdfColors.sections.chartSidebar' | caption}}</h4>
      </div>
      <ng-container *ngFor="let field of getFieldsBySection('chartSidebar')">
        <div nxCol="12,12,6,4" class="color-field">
          <div class="color-label">{{field.label | caption}}</div>
          <div class="color-picker-wrapper">
            <div class="color-preview"
                 [style.backgroundColor]="settings[field.key]"
                 (click)="toggleColorPicker(field.key)">
            </div>
            <span class="color-value">{{settings[field.key]}}</span>
          </div>
          <div class="color-picker-container" [class.open-upward]="openUpward" *ngIf="activeColorPicker === field.key">
            <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
          </div>
        </div>
      </ng-container>
    </div>

    <div nxRow="">
      <div nxCol="12">
        <h4 class="section-title">{{'pdfColors.sections.chartBox' | caption}}</h4>
      </div>
      <ng-container *ngFor="let field of getFieldsBySection('chartBox')">
        <div nxCol="12,12,6,4" class="color-field">
          <div class="color-label">{{field.label | caption}}</div>
          <div class="color-picker-wrapper">
            <div class="color-preview"
                 [style.backgroundColor]="settings[field.key]"
                 (click)="toggleColorPicker(field.key)">
            </div>
            <span class="color-value">{{settings[field.key]}}</span>
          </div>
          <div class="color-picker-container" [class.open-upward]="openUpward" *ngIf="activeColorPicker === field.key">
            <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
          </div>
        </div>
      </ng-container>
    </div>

    <div nxRow="">
      <div nxCol="12">
        <h4 class="section-title">{{'pdfColors.sections.footer' | caption}}</h4>
      </div>
      <ng-container *ngFor="let field of getFieldsBySection('footer')">
        <div nxCol="12,12,6,4" class="color-field">
          <div class="color-label">{{field.label | caption}}</div>
          <div class="color-picker-wrapper">
            <div class="color-preview"
                 [style.backgroundColor]="settings[field.key]"
                 (click)="toggleColorPicker(field.key)">
            </div>
            <span class="color-value">{{settings[field.key]}}</span>
          </div>
          <div class="color-picker-container" [class.open-upward]="openUpward" *ngIf="activeColorPicker === field.key">
            <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
          </div>
        </div>
      </ng-container>
    </div>

    <div nxRow="">
      <div nxCol="12">
        <h4 class="section-title">{{'pdfColors.sections.general' | caption}}</h4>
      </div>
      <ng-container *ngFor="let field of getFieldsBySection('general')">
        <div nxCol="12,12,6,4" class="color-field">
          <div class="color-label">{{field.label | caption}}</div>
          <div class="color-picker-wrapper">
            <div class="color-preview"
                 [style.backgroundColor]="settings[field.key]"
                 (click)="toggleColorPicker(field.key)">
            </div>
            <span class="color-value">{{settings[field.key]}}</span>
          </div>
          <div class="color-picker-container" [class.open-upward]="openUpward" *ngIf="activeColorPicker === field.key">
            <color-chrome [color]="settings[field.key]" (onChangeComplete)="changeColor(field.key, $event)"></color-chrome>
          </div>
        </div>
      </ng-container>
    </div>

    <div nxRow="">
      <div nxCol="12">
        <h4 class="section-title">{{'pdfColors.sections.chartSidebar' | caption}}</h4>
      </div>
      <div nxCol="12,12,6,4" class="color-field">
        <nx-switcher [(checked)]="settings.showSidebarBottomText">
          {{'pdfColors.chartSidebar.showBottomText' | caption}}
        </nx-switcher>
      </div>
    </div>

    <div nxRow="">
      <div nxCol="12">
        <h4 class="section-title">{{'pdfColors.sections.images' | caption}}</h4>
      </div>
      <div nxCol="12,12,6,6" class="image-field">
        <div class="image-label">{{'pdfColors.images.backgroundImage' | caption}}</div>
        <div class="image-preview-wrapper">
          <ng-container *ngIf="settings.backgroundImage">
            <figure nxFigure="">
              <img class="image-preview"
                   [src]="settings.backgroundImage.srcWidth"
                   alt="Background Image"
                   (error)="settings.backgroundImage.srcWidth = 'assets/img/default.png'"
              />
            </figure>
          </ng-container>
          <div class="image-buttons">
            <button nxButton="secondary small" type="button" (click)="openBackgroundImageModal()">
              {{'pdfColors.images.selectImage' | caption}}
            </button>
            <button *ngIf="settings.backgroundImage" nxButton="secondary small" type="button" (click)="removeBackgroundImage()">
              <nx-icon name="trash"></nx-icon>
            </button>
          </div>
        </div>
      </div>
      <div nxCol="12,12,6,6" class="image-field">
        <div class="image-label">{{'pdfColors.images.logoImage' | caption}}</div>
        <div class="image-preview-wrapper">
          <ng-container *ngIf="settings.logoImage">
            <figure nxFigure="">
              <img class="image-preview"
                   [src]="settings.logoImage.srcWidth"
                   alt="Logo Image"
                   (error)="settings.logoImage.srcWidth = 'assets/img/default.png'"
              />
            </figure>
          </ng-container>
          <div class="image-buttons">
            <button nxButton="secondary small" type="button" (click)="openLogoImageModal()">
              {{'pdfColors.images.selectImage' | caption}}
            </button>
            <button *ngIf="settings.logoImage" nxButton="secondary small" type="button" (click)="removeLogoImage()">
              <nx-icon name="trash"></nx-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div nxRow="" class="nx-margin-top-m">
      <div nxCol="12" class="button-row">
        <button nxButton="secondary small" type="button" (click)="resetToDefaults()">
          {{'pdfColors.resetToDefaults' | caption}}
        </button>
        <button nxButton="primary small" type="button" (click)="saveSettings()" [disabled]="saving">
          <nx-spinner *ngIf="saving" nxSize="small" class="nx-margin-right-2xs"></nx-spinner>
          {{'pdfColors.save' | caption}}
        </button>
      </div>
    </div>
  </div>
</div>
